import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { PhotoEditingService } from '@services/photo-editing.service';
import { TagService } from '@services/tag.service';
import { TagInputModule } from 'ngx-chips';
import { SharedModule } from '../../../shared/shared.module';
import { AddPhotoComponent } from './add-photo/add-photo.component';
import { PhotoGalleryComponent } from './photo-gallery/photo-gallery.component';

@NgModule({
    declarations: [
        PhotoGalleryComponent,
        AddPhotoComponent 
    ],
    imports: [
        SharedModule,
        MatProgressSpinnerModule,
        MatSliderModule,
        MatButtonToggleModule,
        NgxGalleryModule,
        TagInputModule
    ],
    providers: [
        PhotoEditingService,
        TagService
    ],
    exports: [
        AddPhotoComponent,
        PhotoGalleryComponent,
    ]
})
export class PatientPhotosModule { }
